import { KEY_CONFIG } from 'lib/ng2-sapmp/src/config/key-config';
import {
  Component, Input, Output, EventEmitter, OnInit, ViewEncapsulation, ElementRef
} from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { CtnLookupModel } from './ctnlookup.model';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CtnNumberService } from './shared/ctnlookup-modal.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ManageInventoryService } from './../shared/providers/manage-inventory.service';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components';

@Component({
  selector: 'app-ctnlookup-modal',
  styleUrls: ['./ctnlookup-modal.component.scss'],
  templateUrl: './ctnlookup-modal.component.html',
  providers: [CtnNumberService],
  encapsulation: ViewEncapsulation.None
})

export class CtnlookupModalComponent implements OnInit {

  @Input()
  modalPopupObject: CtnLookupModel;
  @Input() triggerElement: any;

  @Output()
  modalOutput: EventEmitter<boolean>;

  focusabbleElements: any;
  ctnNumber: any;
  noRecordsFound = false;
  recordsFound = false;
  systemError = false;
  validNumberError  = false;
  ctnNumbertoFormate: FormControl;
  ngOnInit() {
    document.body.classList.add('modal-open');
    this.initCtnNumberformControlObj();
  }

  constructor(private el: ElementRef, private utilityService: UtilityService,
    private ctnNumberService: CtnNumberService,
    private router: Router,
    private manageInventoryService: ManageInventoryService,
    private pageLoaderService: PageLoaderService) {
    this.modalOutput = new EventEmitter<boolean>();
  }


  btnAction(value,event?) {

    if (!event || event.keyCode === KEY_CONFIG.enter || event.keyCode === KEY_CONFIG.space) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

    if (value === false) {
      document.body.classList.remove('modal-open');
      this.modalOutput.emit(value);
      this.focusabbleElements = undefined;
      if (this.triggerElement) {
        this.triggerElement.focus();
      }
    } else {
      this.focusabbleElements = undefined;
      if (this.triggerElement) {
        this.triggerElement.focus();
      }
    }

  }
  }

  loadFocustelements() {
    if (!this.focusabbleElements) {
      const focusableEls = this.utilityService.getFocusableElements(this.el);
      this.focusabbleElements = Array.prototype.slice.call(focusableEls);
      this.focusabbleElements[0].focus();
    }
  }

  handleKeydown(event) {
    if (event.keyCode === KEY_CONFIG.escapeKey) {
      this.btnAction(false);
      return;
    }
    this.utilityService.handleKeyPress(event, this.focusabbleElements);
  }

  initCtnNumberformControlObj() {
    this.ctnNumbertoFormate = new FormControl();
  }
  handleCtnFieldChange() {
    this.noRecordsFound = false;
    this.systemError = false;
    this.validNumberError = false;
  }
  ctnNumberLookUp(ctnNumber,event?) {

    if (!event || event.keyCode === KEY_CONFIG.enter || event.keyCode === KEY_CONFIG.space) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

    if (ctnNumber && ctnNumber.length === 10) {
      if (this.utilityService.getEnvConfig().useMock) {
        this.ctnNumberService.getCtnNumbers(this.utilityService.getEnvConfig().ctnNumberUrl).subscribe(response => {
          const ctnDetails = response;
          this.manageInventoryService.setSelectedCtn(ctnDetails.ctn);
          if (ctnDetails.ctn === ctnNumber) {
            this.btnAction(false);
            this.recordsFound = true;
            this.noRecordsFound = false;
            sessionStorage.setItem('ctnDetails', JSON.stringify(ctnDetails));
            this.router.navigate(['manageInventory/ctnInfo']);
          } else {
            this.recordsFound = false;
            this.noRecordsFound = true;
          }
          this.pageLoaderService.setPageLoaderStatus(true);
        }, error => { 
          if( error.status === 400 || error.status === 404){ 
            this.recordsFound = false;
            this.noRecordsFound = true;
          } else { 
            this.systemError = true;
          }
        });
      } else {
        this.pageLoaderService.setPageLoaderStatus(false);
        this.validNumberError = false;
        this.ctnNumberService.getCtnNumbers(this.utilityService.getEnvConfig().ctnNumberUrl);
        this.manageInventoryService.getCtnDetails(ctnNumber)
          .subscribe(response => {
            const ctnDetails = response.ctnDetailsResponseList[0];
            this.manageInventoryService.setSelectedCtn(ctnDetails.ctn);
            if (ctnDetails.ctn === ctnNumber) {
              this.btnAction(false);
              this.recordsFound = true;
              this.noRecordsFound = false;
              sessionStorage.setItem('ctnDetails', JSON.stringify(ctnDetails));
              this.router.navigate(['manageInventory/ctnInfo']);
            } else {
              this.recordsFound = false;
              this.noRecordsFound = true;
            }
            this.pageLoaderService.setPageLoaderStatus(true);
          }, error => {
            if( error.status === 400 || error.status === 404){
              this.recordsFound = false;
              this.noRecordsFound = true;
            } else {
              this.systemError = true;
            }
            this.pageLoaderService.setPageLoaderStatus(true);
          });
      }
    } else {
      this.validNumberError = true;
    }

  }
  }
}
